import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { toast } from "sonner";
import { useRequireRole } from "@/lib/use-require-role";
import { PageHeader } from "@/components/page-header";
import { Switch } from "@/components/ui/switch";
import { featureFlags, organizations, orgFeatureFlags } from "@/mocks/saas-data";

export const Route = createFileRoute("/admin/feature-flags")({
  ssr: false,
  head: () => ({ meta: [{ title: "Admin — Feature Flags" }] }),
  component: Page,
});

function Page() {
  const user = useRequireRole(["superadmin"]);
  const [tick, setTick] = useState(0);
  if (!user) return null;

  return (
    <div className="mx-auto max-w-5xl px-6 py-8 lg:px-10 lg:py-10">
      <PageHeader title="Feature flags" description="Global defaults and per-org overrides." />
      <div className="space-y-6">
        {featureFlags.map((f) => (
          <div key={f.key} className="rounded-xl bg-card p-5 ring-1 ring-border">
            <div className="flex items-center justify-between">
              <div>
                <p className="font-mono text-sm font-medium">{f.key}</p>
                <p className="text-xs text-muted-foreground">{f.description}</p>
              </div>
              <div className="flex items-center gap-2">
                <span className="font-mono text-[10px] uppercase text-muted-foreground">default</span>
                <Switch
                  checked={f.defaultValue}
                  onCheckedChange={(v) => { f.defaultValue = v; toast.success(`Default ${f.key} = ${v}`); setTick((t) => t + 1); }}
                />
              </div>
            </div>
            <div className="mt-4 grid grid-cols-2 gap-2 border-t border-border pt-4 md:grid-cols-4">
              {organizations.map((o) => {
                const override = orgFeatureFlags[o.id]?.[f.key];
                const value = override ?? f.defaultValue;
                return (
                  <label key={o.id} className="flex items-center justify-between gap-2 rounded-md border border-border px-3 py-2 text-xs">
                    <span className="truncate">{o.name}</span>
                    <Switch
                      checked={value}
                      onCheckedChange={(v) => {
                        if (!orgFeatureFlags[o.id]) orgFeatureFlags[o.id] = {};
                        orgFeatureFlags[o.id][f.key] = v;
                        toast.success(`${o.name}: ${f.key} = ${v}`);
                        setTick((t) => t + 1);
                      }}
                    />
                  </label>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      <span className="hidden">{tick}</span>
    </div>
  );
}
